var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { HttpClient } from "@/lib/http";
// KPI Type definitions
export const KPI_GLOBAL_PERFORMANCE_TYPES = [
    { value: "area", label: "Área" },
    { value: "region", label: "Región" },
    { value: "delegation", label: "Delegación" },
    { value: "sala", label: "Sala" },
    { value: "distribuidor", label: "Distribuidor" },
];
export function fetchKpiGlobalPerformance() {
    return __awaiter(this, arguments, void 0, function* (params = {}) {
        const url = "/webapi/resultados/center-kpi-global-performance";
        const response = yield HttpClient.get(url, Object.assign({}, params));
        return response !== null && response !== void 0 ? response : [];
    });
}
